"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerTransition = void 0;

var _gatsby = require("gatsby");

var _random = _interopRequireDefault(require("lodash/random"));

var _requestanimationframeTimer = require("requestanimationframe-timer");

var _secondsMs = require("./secondsMs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var triggerTransition = function triggerTransition(_ref) {
  var to = _ref.to,
      _ref$event = _ref.event,
      event = _ref$event === void 0 ? null : _ref$event,
      _ref$exit = _ref.exit,
      exit = _ref$exit === void 0 ? {} : _ref$exit,
      _ref$entry = _ref.entry,
      entry = _ref$entry === void 0 ? {} : _ref$entry,
      inTransition = _ref.inTransition,
      transitionIdHistory = _ref.transitionIdHistory,
      updateContext = _ref.updateContext;
  event.persist();
  event.preventDefault();
  if (inTransition) return false;
  updateContext({
    inTransition: true,
    exitDelay: 0,
    exitLength: 0,
    exitState: {}
  });

  var _exit$length = exit.length,
      exitLength = _exit$length === void 0 ? 0 : _exit$length,
      _exit$delay = exit.delay,
      exitDelay = _exit$delay === void 0 ? 0 : _exit$delay,
      _exit$state = exit.state,
      exitState = _exit$state === void 0 ? {} : _exit$state,
      _exit$trigger = exit.trigger,
      _exitTrigger = _exit$trigger === void 0 ? function () {} : _exit$trigger;

  var _entry$length = entry.length,
      entryLength = _entry$length === void 0 ? 0 : _entry$length,
      _entry$delay = entry.delay,
      entryDelay = _entry$delay === void 0 ? 0 : _entry$delay,
      _entry$state = entry.state,
      entryState = _entry$state === void 0 ? {} : _entry$state,
      _entry$trigger = entry.trigger,
      _entryTrigger = _entry$trigger === void 0 ? function () {} : _entry$trigger;

  updateContext({
    entryLength: entryLength,
    entryDelay: entryDelay,
    exitLength: exitLength,
    exitDelay: exitDelay,
    entryProps: entry,
    exitProps: exit,
    exitTrigger: function exitTrigger(exit, node, e) {
      return _exitTrigger(exit, node, e);
    },
    entryTrigger: function entryTrigger(entry, node, e) {
      return _entryTrigger(entry, node, e);
    },
    e: event
  });
  (0, _requestanimationframeTimer.setTimeout)(function () {
    // after exitDelay
    var transitionId = (0, _random.default)(10000, 99999, false);
    (0, _gatsby.navigate)(to, {
      state: {
        transitionId: transitionId
      }
    });
    updateContext({
      exitState: exitState,
      transitionIdHistory: _toConsumableArray(transitionIdHistory).concat([transitionId])
    });
  }, (0, _secondsMs.getMs)(exitDelay));
  (0, _requestanimationframeTimer.setTimeout)(function () {
    // wait for entryDelay before we add entry state
    updateContext({
      entryState: entryState
    });
  }, (0, _secondsMs.getMs)(exitDelay + entryDelay)); // reset animation times so they dont apply when using browser back/forward.
  //  this will be replaced with a better solution in the future

  (0, _requestanimationframeTimer.setTimeout)(function () {
    return updateContext({
      entryDelay: 0,
      entryLength: 0,
      exitDelay: 0,
      exitLength: 0,
      inTransition: false
    });
  }, (0, _secondsMs.getMs)(exitDelay + entryDelay + entryLength + exitLength));
};

exports.triggerTransition = triggerTransition;